import { Component } from '@angular/core';
import { ICON_TYPE } from "../../../icons/icon.model";

@Component({
  selector: 'app-custom-button-switch',
  templateUrl: './custom-button-switch.component.html',
  styleUrls: ['./custom-button-switch.component.scss'],
  standalone: false
})
export class CustomButtonSwitchComponent {

  iconTypes = ICON_TYPE;

  constructor() {}
}
